var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c(_vm.layout,{tag:"component"},[_c('router-view')],1),_c('v-snackbar',{attrs:{"value":_vm.snackbar,"timeout":-1,"color":"rgba(0, 0, 0, 0.75)"}},[_vm._v(" "+_vm._s(_vm.snackbarText)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }